/* Callisto: smarte smykkeforslag – "Fuldend dit sæt" på produktsiden og forslagene i kurven.
   Bygger på Shopifys anbefalinger for HVERT smykke i kurven (eller produktet man står på):
   - "Købes ofte sammen" (komplementære) vægter højest, derefter "relaterede".
   - Et smykke, der foreslås til flere af smykkerne i kurven, rykker op.
   - Smykker, der allerede er i kurven, og samme smykke i en anden farve springes over.
   - Samme metal som kunden har valgt (guld/sølv) foretrækkes.
   - Mangler der forslag, fyldes op med de kort, der allerede står (Bestsellere).
   - Gaveæske og smykkepose foreslås aldrig.
   - Rolig visning: rækken står usynlig med fri plads, til de rigtige kort er klar, og tones så blødt frem.
     Når kurven opdateres, sættes de sidst viste forslag ind med det samme (før skærmen tegnes), og skift sker med en blød overgang. */
(function () {
  if (window.ClSmartRecs) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var GAVE = /^(gaveaeske|smykkepose)$/;

  /* Blød fremtoning af forslagsrækkerne */
  try {
    var st = document.createElement('style');
    st.textContent = '[data-cl-smart],[data-cl-set-recs]{transition:opacity .28s ease}[data-cl-smart].cl-recs-fade{opacity:0!important;animation:none!important}';
    document.head.appendChild(st);
  } catch (e) {}

  function base(t) {
    return String(t || '').toLowerCase()
      .replace(/18\s*k|guldbelagt|forgyldt|guld|gold|sølv|silver/g, ' ')
      .replace(/\d+(?:[.,]\d+)?\s*mm/g, ' ')
      .replace(/[^a-z0-9æøåé]+/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function metalOf(t) {
    t = String(t || '');
    if (/guld|gold|18\s*k/i.test(t)) return 'gold';
    if (/sølv|silver/i.test(t)) return 'silver';
    return 'silver';
  }

  function hent(pid, intent) {
    var k = pid + '|' + intent;
    if (!cache[k]) {
      cache[k] = fetch(root + 'recommendations/products?section_id=cl-set-recs&limit=10&intent=' + intent + '&product_id=' + pid, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          return [].slice.call(d.querySelectorAll('[data-rec]')).map(function (el) {
            return { pid: el.getAttribute('data-pid'), title: el.getAttribute('data-title') || '', metal: el.getAttribute('data-metal') || '', el: el };
          });
        })
        .catch(function () { return []; });
    }
    return cache[k];
  }

  /* sources: [{pid, title}] – nyeste først. opts: {max, style, metal, exclude: [pid], reserve: [card]} */
  function rank(sources, opts) {
    var excl = {}, exclBase = {};
    sources.forEach(function (s) { excl[s.pid] = 1; exclBase[base(s.title)] = 1; });
    (opts.exclude || []).forEach(function (p) { excl[p] = 1; });
    return Promise.all(sources.map(function (s) { return Promise.all([hent(s.pid, 'complementary'), hent(s.pid, 'related')]); }))
      .then(function (res) {
        var score = {}, info = {};
        function add(c, v) {
          if (!c.pid || excl[c.pid] || exclBase[base(c.title)]) return;
          score[c.pid] = (score[c.pid] || 0) + v;
          info[c.pid] = c;
        }
        res.forEach(function (pair, si) {
          var w = si === 0 ? 1 : 0.85;
          pair[0].forEach(function (c, r) { add(c, w * (3 + (10 - r) / 10)); });
          pair[1].forEach(function (c, r) { add(c, w * ((10 - r) / 10)); });
        });
        Object.keys(score).forEach(function (pid) {
          var m = info[pid].metal || metalOf(info[pid].title);
          if (opts.metal && m) score[pid] += (m === opts.metal ? 0.6 : -0.6);
        });
        var ids = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
        var out = [], seenBase = {}, seenPid = {};
        ids.forEach(function (pid) {
          if (out.length >= opts.max) return;
          var b = base(info[pid].title);
          if (seenBase[b]) return;
          var card = info[pid].el.querySelector('[data-style="' + opts.style + '"] [data-cm-card]');
          if (!card) return;
          seenBase[b] = 1; seenPid[pid] = 1;
          out.push(card.cloneNode(true));
        });
        (opts.reserve || []).forEach(function (c) {
          if (out.length >= opts.max) return;
          var pid = c.getAttribute('data-product-id'), b = base(c.getAttribute('data-title'));
          if (excl[pid] || exclBase[b] || seenBase[b] || seenPid[pid] || GAVE.test(c.getAttribute('data-handle') || '') || /gaveæske|smykkepose/i.test(c.getAttribute('data-title') || '')) return;
          seenBase[b] = 1; seenPid[pid] = 1;
          out.push(c);
        });
        return out;
      });
  }

  function cartJs() { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function erSmykke(i) { return !i.gift_card && i.handle !== 'gaveaeske' && i.handle !== 'smykkepose'; }
  function sæt(box, list) {
    box.innerHTML = '';
    list.forEach(function (c) { box.appendChild(c); });
    if (window.Claury && Claury.init) Claury.init(box);
  }
  function vis(boxes) { boxes.forEach(function (b) { b.classList.remove('cl-recs-loading'); }); }
  /* Skift kortene med en kort, blød overgang, hvis rækken allerede er synlig – ellers bare sæt dem ind */
  function blødtSæt(b, list) {
    if (b.classList.contains('cl-recs-loading') || !b.isConnected) { sæt(b, list); return; }
    b.classList.add('cl-recs-fade');
    setTimeout(function () {
      sæt(b, list);
      requestAnimationFrame(function () { b.classList.remove('cl-recs-fade'); });
    }, 200);
  }

  /* ---------- Produktsiden: Fuldend dit sæt ---------- */
  function pdp() {
    var g = document.querySelector('[data-cl-set-recs]:not([data-cl-smart])');
    if (!g) return;
    g.setAttribute('data-cl-smart', '');
    var reserve = [].slice.call(g.querySelectorAll('[data-cm-card]'));
    var max = parseInt(g.getAttribute('data-max'), 10) || 3;
    var src = { pid: g.getAttribute('data-product-id'), title: g.getAttribute('data-title') || '' };
    var metal = g.getAttribute('data-metal') || metalOf(src.title);
    var t = setTimeout(function () { vis([g]); }, 2500);
    rank([src], { max: max, style: 'tile', metal: metal, reserve: reserve })
      .then(function (list) {
        if (list.length) sæt(g, list);
        return cartJs().then(function (cart) {
          var ids = {}, pids = {};
          (cart.items || []).forEach(function (i) { ids[i.variant_id] = true; pids[i.product_id] = true; });
          g.querySelectorAll('[data-cm-card]').forEach(function (card) {
            var inCart = !!ids[card.dataset.variantId] || !!pids[card.dataset.productId];
            card.classList.toggle('is-added', inCart);
            var btn = card.querySelector('[data-cm-action="add"]');
            if (btn) {
              btn.classList.toggle('is-added', inCart);
              btn.setAttribute('aria-label', inCart ? 'Ligger i kurven' : 'Læg ' + (card.dataset.title || '') + ' i kurven');
            }
          });
        });
      })
      .catch(function () {})
      .then(function () { clearTimeout(t); vis([g]); });
  }

  /* ---------- Kurven: forslag ud fra alle smykker i kurven ---------- */
  var sidste = { mini: null };   // seneste viste forslag – bruges med det samme, så listen ikke blinker, når kurven opdateres
  function fraSiden() {
    var rows = [].slice.call(document.querySelectorAll('.quick-cart .quick-cart__item[data-product-id]'));
    if (!rows.length) return null;
    return rows.map(function (r) {
      var t = r.querySelector('.quick-cart__item-title');
      var v = r.querySelector('.quick-cart__item-variant');
      var q = r.querySelector('[data-quantity-input]');
      return { pid: String(r.getAttribute('data-product-id')), title: t ? t.textContent.trim() : '', variant: v ? v.textContent.trim() : '', qty: q ? (parseInt(q.value, 10) || 1) : 1 };
    });
  }
  function fraKurv() {
    return cartJs().then(function (cart) {
      return (cart.items || []).filter(erSmykke).map(function (i) {
        return { pid: String(i.product_id), title: i.product_title, variant: i.variant_title || '', qty: i.quantity };
      });
    });
  }
  function kurv() {
    var boxes = [].slice.call(document.querySelectorAll('.cx-upm__row:not([data-cl-smart]), .cx-upd__list:not([data-cl-smart])'));
    if (!boxes.length) return;
    boxes.forEach(function (b) { b.setAttribute('data-cl-smart', ''); });
    var dom = fraSiden();
    var iKurv = {};
    (dom || []).forEach(function (i) { iKurv[i.pid] = 1; });
    /* Straks: vis de forslag, der stod før (minus det, der nu ligger i kurven) – ingen tom eller blinkende liste */
    var straks = false;
    if (sidste.mini && dom) {
      boxes.forEach(function (b) {
        var max = b.querySelectorAll('[data-cm-card]').length || 6;
        var liste = sidste.mini.filter(function (c) { return !iKurv[c.getAttribute('data-product-id')]; }).slice(0, max).map(function (c) { return c.cloneNode(true); });
        if (liste.length >= Math.min(max, 3)) { sæt(b, liste); straks = true; }
      });
    }
    if (straks) vis(boxes);
    if (!straks) boxes.forEach(function (b) { b.classList.add('cl-recs-loading'); });
    var t = setTimeout(function () { vis(boxes); }, 2500);
    (dom ? Promise.resolve(dom) : fraKurv()).then(function (items) {
      items = (items || []).filter(function (i) { return i.title && !/gaveæske|smykkepose/i.test(i.title); });
      if (!items.length) return;
      var srcs = [], seen = {}, guld = 0, soelv = 0;
      items.forEach(function (i) {
        if (metalOf(i.title + ' ' + i.variant) === 'gold') guld += i.qty; else soelv += i.qty;
        if (seen[i.pid] || srcs.length >= 5) return;
        seen[i.pid] = 1;
        srcs.push({ pid: i.pid, title: i.title });
      });
      var metal = guld > soelv ? 'gold' : (soelv > guld ? 'silver' : '');
      var exclude = items.map(function (i) { return i.pid; });
      return Promise.all(boxes.map(function (b) {
        var reserve = [].slice.call(b.querySelectorAll('[data-cm-card]'));
        var max = reserve.length || 6;
        return rank(srcs, { max: max, style: 'mini', metal: metal, exclude: exclude, reserve: reserve })
          .then(function (list) {
            if (!list.length) return;
            var nu = [].slice.call(b.querySelectorAll('[data-cm-card]')).map(function (c) { return c.getAttribute('data-product-id'); }).join(',');
            var ny = list.map(function (c) { return c.getAttribute('data-product-id'); }).join(',');
            sidste.mini = list.map(function (c) { return c.cloneNode(true); });
            if (nu !== ny) blødtSæt(b, list);
          });
      }));
    })
      .catch(function () {})
      .then(function () { clearTimeout(t); vis(boxes); });
  }

  function kør() { pdp(); kurv(); }
  var venter = null;
  function senere() { clearTimeout(venter); venter = setTimeout(kør, 60); }
  var NY_KURV = '.cx-upm__row:not([data-cl-smart]), .cx-upd__list:not([data-cl-smart])';
  /* Hent anbefalingerne for kurvens smykker i baggrunden, så forslagene står klar, når kurven åbnes */
  function forvarm() {
    fraKurv().then(function (items) {
      var n = 0, seen = {};
      (items || []).forEach(function (i) {
        if (seen[i.pid] || n >= 5) return;
        seen[i.pid] = 1; n++;
        hent(i.pid, 'complementary'); hent(i.pid, 'related');
      });
    }).catch(function () {});
  }
  function start() {
    kør();
    new MutationObserver(function () {
      /* Ny kurv-skuffe: sæt forslag ind med det samme (før skærmen tegnes), så der ikke blinker andre kort først */
      if (document.querySelector(NY_KURV)) kurv();
      senere();
    }).observe(document.body, { childList: true, subtree: true });
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(forvarm);
    document.addEventListener('cart:updated', function () { idle(forvarm); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.ClSmartRecs = { rank: rank, base: base };
})();
